import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';
import { personalInfoType } from '../../../common/interfaces/myProfile/personalDetails/personalInfo';

const initialState: personalInfoType = {
  firstName: '',
  lastName: '',
  DOB: '',
  gender: '',
  martialStatus: '',
  country: '',
  email: '',
  phone: '',
  countryId: 0,
  genderId: 0,
  maritalStatusId: 0,
  state: '',
  stateId: 0,
  education: '',
  religious: '',
  nationalityId: 0,
  nationalityName: '',
};

const personalInfoSlice = createSlice({
  name: 'personalInformation',

  initialState,
  reducers: {
    personalInfoReducer: (
      state: personalInfoType,
      action: PayloadAction<personalInfoType>,
    ) => {
      const payload = action.payload;
      state.firstName = payload.firstName;
      state.lastName = payload.lastName;
      state.DOB = payload.DOB;
      state.gender = payload.gender;
      state.martialStatus = payload.martialStatus;
      state.country = payload.country;
      state.email = payload.email;
      state.phone = payload.phone;
      state.countryId = payload.countryId;
      state.genderId = payload.genderId;
      state.maritalStatusId = payload.maritalStatusId;
      state.state = payload.state;
      state.stateId = payload.stateId;
      state.education = payload.education;
      state.religious = payload.religious;
      state.nationalityId = payload.nationalityId;
      state.nationalityName = payload.nationalityName;
    },
    updatePersonalInfo: (
      state: personalInfoType,
      action: PayloadAction<personalInfoType>,
    ) => {
      const payload = action.payload;
      state.firstName = payload.firstName;
      state.lastName = payload.lastName;
      state.DOB = payload.DOB;
      state.gender = payload.gender;
      state.martialStatus = payload.martialStatus;
      state.country = payload.country;
      state.email = payload.email;
      state.phone = payload.phone;
      state.countryId = payload.countryId;
      state.genderId = payload.genderId;
      state.maritalStatusId = payload.maritalStatusId;
      state.state = payload.state;
      state.stateId = payload.stateId;
      state.education = payload.education;
      state.religious = payload.religious;
      state.nationalityId = payload.nationalityId;
      state.nationalityName = payload.nationalityName;
    },
    resetPersonalInfo: (state: personalInfoType) => {
      state.firstName = '';
      state.lastName = '';
      state.DOB = new Date();
      state.gender = '';
      state.martialStatus = '';
      state.country = '';
      state.email = '';
      state.phone = '';
      state.countryId = 0;
      state.genderId = 0;
      state.maritalStatusId = 0;
      state.stateId = 0;
      state.state = '';
      state.education = '';
      state.religious = '';
      state.nationalityId = 0;
      state.nationalityName = '';
    },
  },
});

export const { personalInfoReducer, resetPersonalInfo, updatePersonalInfo } =
  personalInfoSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default personalInfoSlice.reducer;
